function init() {
    const hasVideo = document.querySelector('.videoOverlay');

    if (hasVideo) {
        youTubeOverlay('.videoOverlay');
    }
}

$(document).ready(init);
